/*
==========================================================
PLATFORM ERRORS
==========================================================
*/

export const PLATFORM_ERRORS = {

  /*
  ==========================================================
  ACCESS REQUEST
  ==========================================================
  */

  ACCESS_REQUEST_NOT_FOUND:
    "ACCESS_REQUEST_NOT_FOUND",

  ACCESS_REQUEST_ALREADY_APPROVED:
    "ACCESS_REQUEST_ALREADY_APPROVED",

  ACCESS_REQUEST_ALREADY_REJECTED:
    "ACCESS_REQUEST_ALREADY_REJECTED",

  ACCESS_REQUEST_ALREADY_EXISTS:
    "ACCESS_REQUEST_ALREADY_EXISTS",

  /*
  ==========================================================
  COMPANY
  ==========================================================
  */

  COMPANY_NOT_FOUND:
    "COMPANY_NOT_FOUND",

  COMPANY_ALREADY_EXISTS:
    "COMPANY_ALREADY_EXISTS",

  /*
  ==========================================================
  USER
  ==========================================================
  */

  USER_NOT_FOUND:
    "USER_NOT_FOUND",

  USER_ALREADY_EXISTS:
    "USER_ALREADY_EXISTS",

  INVALID_ROLE:
    "INVALID_ROLE",

  /*
  ==========================================================
  GENERAL
  ==========================================================
  */

  VALIDATION_ERROR:
    "VALIDATION_ERROR",

  PERMISSION_DENIED:
    "PERMISSION_DENIED",

  UNKNOWN_ERROR:
    "UNKNOWN_ERROR"

};

export default PLATFORM_ERRORS;